import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_DetailTab = _resolveComponent("DetailTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_MetadataCard = _resolveComponent("MetadataCard")
  const _component_PersistenceTab = _resolveComponent("PersistenceTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "qbe-saving-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.descriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('qbe.savingDialog.title')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        disabled: _ctx.buttonDisabled,
        onClick: _ctx.saveDataset
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_TabView, {
        class: "tabview-custom",
        activeIndex: _ctx.activeTab,
        "onUpdate:activeIndex": _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = $event)),
        "data-test": "tab-view"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('managers.mondrianSchemasManagement.detail.title')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_DetailTab, {
                propDataset: _ctx.propDataset,
                scopeTypes: _ctx.scopeTypes,
                categoryTypes: _ctx.categoryTypes
              }, null, 8, ["propDataset", "scopeTypes", "categoryTypes"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.measureDefinition.metadata')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_MetadataCard, {
                propMetadata: _ctx.propMetadata,
                onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["propMetadata"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('qbe.savingDialog.persistence')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_PersistenceTab, {
                propDataset: _ctx.propDataset,
                schedulingData: _ctx.scheduling
              }, null, 8, ["propDataset", "schedulingData"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}